module.exports = __webpack_public_path__ + "static/media/beef-bacon.1cd36af3.jpg";